import React from 'react';

const Separator = () => {
  return (
    <div className='h-[40px] w-full bg-mOrange'></div>
  );
}

export default Separator;
